import Cookies from 'js-cookie'
const getConfigToken = () => {
    const config = {
        headers: {
            token: Cookies.get('token')
        }
    }
    return config
}
export default getConfigToken()